import React, { useEffect } from 'react';
import { Box, VStack } from 'native-base';
import {
    useGetMilestones,
    useSpringBigStore,
    useI18n,
    fakeItemsArray
} from '@springbig/shared';
import CardMilestone, { CardMilestoneSkeleton } from './components/CardMilestone';
import Section from '~/shared/Section';
import { useAuthorization } from '~/hooks/auth';
import SuspendedMerchantScreen from '~/shared/SuspendedMerchantScreen';
import { NoDataPlaceholder } from '~/shared/NoDataPlaceholder';
import { faTrophy } from '@fortawesome/free-solid-svg-icons';

const MilestoneScreen = () => {

    const { isLoadingAuth } = useAuthorization();
    const { walletId, member } = useSpringBigStore();

    const {
        refetch,
        data,
        isLoading
    } = useGetMilestones();
    const { t } = useI18n();

    useEffect(() => {
        if (walletId) {
            refetch();
        }
    }, [walletId]);

    if (isLoading || isLoadingAuth || !member || !walletId) {
        return <MilestoneSkeleton />;
    }

    if (
        !data?.milestones?.spend_milestones?.length &&
        !data?.milestones?.points_milestones?.length &&
        !data?.milestones?.visits_milestones?.length
    ) {
        return (<NoDataPlaceholder
            title={t('common.milestones_placeholder_title')}
            message={t('common.milestones_placeholder_subtitle')}
            callback={refetch}
            isLoading={isLoading}
            iconName={faTrophy}
        />);
    }

    return (
        <Section flex={1} w={'100%'} overflowY={'auto'}>
            { member && member.show_pending_modal &&
                <SuspendedMerchantScreen />
            }
            <VStack space={4}>
                { data?.milestones?.spend_milestones?.length > 0 && (
                    <>
                        { data.milestones.spend_milestones.map((item, index) => {
                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={item.value - item.remaining}
                                    milestone={item}
                                    t={t}
                                    type={'spend'}
                                />
                            );
                        })}
                    </>
                )}
                { data?.milestones?.points_milestones?.length > 0 && (
                    <>
                        { data.milestones.points_milestones.map((item, index) => {
                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={item.value - item.remaining}
                                    milestone={item}
                                    t={t}
                                    type={'points'}
                                />
                            );
                        })}
                    </>
                )}
                { data?.milestones?.visits_milestones?.length > 0 && (
                    <>
                        { data.milestones.visits_milestones.map((item, index) => {
                            return (
                                <CardMilestone
                                    key={index}
                                    currentValue={data.milestones.lifetime_visits}
                                    milestone={item}
                                    t={t}
                                    type={'visits'}
                                />
                            );
                        })}
                    </>
                )}
            </VStack>
        </Section>
    );
};

const MilestoneSkeleton = () => {

    return (
        <>
            {fakeItemsArray.map((_, index) => (

                <Box key={index} my={2}>
                    <CardMilestoneSkeleton />
                </Box>
            ))}
        </>
    );
};

export default MilestoneScreen;
